module.exports = __webpack_public_path__ + "img/triangle-half.3eb30d67.svg";